import { svg } from "lit";
const icon = svg `<path d="M3.41699 16.5826V3.41602H10.0083V4.49933H4.5003V15.4993H10.0083V16.5826H3.41699ZM13.6926 12.8903L12.9106 12.1323L14.5019 10.541H8.08043V9.45768H14.5019L12.9106 7.86633L13.6926 7.10835L16.5836 9.99933L13.6926 12.8903Z" fill="currentColor"/>`;
export default icon;
